import { Reducer } from "redux";
import { ChapterState, Chapter } from "./@types";
import { TAction } from "loop-front";
import { OChapter } from "./Model";
import utilities from "../../Resources/Utils";

export const Chapters: Reducer<ChapterState, TAction> = (state: ChapterState = {}, action: TAction) => {
    switch (action.type) {
        case OChapter.Actions.LIST_RECEIVED: return { ...state, mainList: action.data }

        case OChapter.Actions.ACTIVITY_POST_SUCCESS: {
            switch (action.activity) {
                case OChapter.Activities.TOGGLE_PUBLISH: return { ...state, mainList: utilities.updateItemList(state.mainList || [], action.data, 'PUT') }
                default: return state;
            }
        }

        case OChapter.Actions.POST_ITEM_SUCCESS:
        case OChapter.Actions.PUT_ITEM_SUCCESS: return { ...state, mainList: utilities.updateItemList(state.mainList || [], action.data, 'PUT') }

        case OChapter.Actions.ITEM_DELETED: return { ...state, mainList: utilities.updateItemList(state.mainList || [], { id: action.additionalDispatchData.deletedItemId } as Chapter, 'DELETE') }

        default: return state;
    }
}